import React, { useEffect, useState } from 'react'
import LeftPanel from '../../../components/LeftPanel'
import Header from '../../../components/Header'
import { ArrowDropDown } from '@mui/icons-material';

import ItemCosting from "../../../components/ItemCosting"
import DatePicker from "react-datepicker";
import { Search } from "@mui/icons-material";
import JsPDF from 'jspdf';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import axios from 'axios';
import { openDB } from 'idb';
const ProfitAndLoss = () => {
    const [costPopup, setCostPopup] = useState(false)
    const [active, setActive] = useState("order")
    const [statementBar, setStatmentBar] = useState(false)
    const [itemsDetails, setItemsDetails] = useState([])
    const [statementDetails, setStatementDetails] = useState([])
    const [orderItemsDetails, setOrderItemsDetails] = useState([])
    const [startDate, setStartDate] = useState((new Date(Date.UTC(new Date(parseFloat(localStorage.getItem("current-working-day")))?.getFullYear().toString(), new Date(parseFloat(localStorage.getItem("current-working-day")))?.getMonth().toString(), new Date(parseFloat(localStorage.getItem("current-working-day")))?.getDate().toString(), '00', '00', '00'))).getTime())
    const [endDate, setEndDate] = useState((new Date(Date.UTC(new Date(parseFloat(localStorage.getItem("current-working-day")))?.getFullYear().toString(), new Date(parseFloat(localStorage.getItem("current-working-day")))?.getMonth().toString(), new Date(parseFloat(localStorage.getItem("current-working-day")))?.getDate().toString(), '00', '00', '00'))).getTime())
    let dateFormate = sessionStorage.getItem("date_format")
    const [itemGroupingData, setItemGroupingData] = useState([])
    const [itemGroupingFilter, setItemGroupingFilter] = useState(null)
    const getItemGroupingData = async () => {
        const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        const tx = await db.transaction("item_grouping", "readwrite").objectStore("item_grouping");
        const data = await tx.getAll();
        setItemGroupingData(data)
    }
    useEffect(() => getItemGroupingData(), [])
    useEffect(() => setCostPopup(true), [])
    const onSearch = async () => {
        // let timeDifference = (new Date(parseFloat(localStorage.getItem("current-working-day")))).getDate()
        //     - (new Date(startDate)).getDate()
        // // console.log((parseInt(restrictions[0]?.other_report_Daily_summary) || 0) , timeDifference)
        // if (restrictions.length && (parseInt(restrictions[0]?.other_report_item_sale) || 0) < timeDifference) {
        //     setUnAuthPopup(true)
        //     setTimeout(() => setUnAuthPopup(false), 3000)
        //     return
        // }
        const result = await axios({
            url: "https://api.myfooddo.com/order/getOrderProfitAndLossDetails",
            method: "post",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            data: [{
                start_date: startDate,
                end_date: endDate,
                outlet_uuid: localStorage.getItem("outlet_uuid"),
            }]
        })

        // console.log(result.data.result)
        setOrderItemsDetails(result.data.result || [])
        const response = await axios({
            url: "https://api.myfooddo.com/order/getItemProfitAndLossDetails",
            method: "post",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            data: [{
                start_date: startDate,
                end_date: endDate,
                outlet_uuid: localStorage.getItem("outlet_uuid"),
            }]
        })

        console.log(response.data.result)
        setItemsDetails(response.data.result || [])
        const response2 = await axios({
            url: "https://api.myfooddo.com/order/getStatementProfitAndLossDetails",
            method: "post",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            data: [{
                start_date: startDate,
                end_date: endDate,
                outlet_uuid: localStorage.getItem("outlet_uuid"),
            }]
        })

        setStatementDetails(response2.data.result || [])
    }
    const totalOrderProfitLoss = () => {
        let total = 0
        for (let i of orderItemsDetails) {
            total = total + i.P_L
        }
        return total
    }
    const totalItemProfitLoss = () => {
        let total = 0
        for (let i of itemsDetails.filter(a => !itemGroupingFilter || itemGroupingData.find(b => b.item_group_uuid === itemGroupingFilter)?.items?.filter(b => b === a.item_uuid).length)) {
            total = total + i.P_L
        }
        return total
    }
    const totalOrderData = () => {
        let total = 0
        for (let i of orderItemsDetails) {
            total = total + i.order_total
        }
        return total
    }
    const totalSaleQty = () => {
        let total = 0
        for (let i of itemsDetails.filter(a => !itemGroupingFilter || itemGroupingData.find(b => b.item_group_uuid === itemGroupingFilter)?.items?.filter(b => b === a.item_uuid).length)) {
            total = total + i.sale_qty
        }
        return total
    }
    const printDocument = () => {


        const report = new JsPDF('landscape', 'pt', "a4");
        report.html(document.getElementById('xlsTableToPrint')).then(() => {
            report.save('Profit_Loss_Report.pdf');
        });
    }

    return (<>

        <LeftPanel />
        <Header />
        <div className="customer-reports-container orders-report-container" >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", position: "absolute", width: active === "order" || itemGroupingData.length === 0 ? "10vw" : "50vw", right: "10vw", top: "110px" }}>
                {active === "order" ? "" : itemGroupingData.length === 0 ? "" : <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "250px" }}>Item Grouping Filter
                    <select style={{ width: "100px" }} onChange={e => setItemGroupingFilter(e.target.value)} value={itemGroupingFilter}>
                        <option value="">All</option>
                        {itemGroupingData.map(a => <option value={a.item_group_uuid}>{a.item_group_title}</option>)}
                    </select></div>}
                <div>
                    <ReactHTMLTableToExcel
                        className="hoverIcons"
                        style={{ cursor: "pointer", }}
                        table="xlsTableToPrint"
                        sheet="Sheet"
                        filename="orders-report"
                        buttonText="Excel"
                    />
                    <button className="hoverIcons" onClick={printDocument} style={{ cursor: "pointer" }}>
                        {/* <PictureAsPdf style={{ fontSize: "30px" }} /> */}
                        PDF
                    </button></div>

            </div>
            <div id="heading">
                <h2>Profit and Loss Estimate</h2>
            </div>
            <div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between", padding: "0 10px" }}>
                <div style={{ display: "flex", width: "600px", alignItems: "center", justifyContent: "space-between" }}>
                    <div
                        style={{ display: "flex", width: "200px", padding: "0px 0", alignItems: "left", justifyContent: "space-between", flexDirection: "column" }}
                    >
                        <label htmlFor="date-from" style={{ width: "50%", }}>From date</label>
                        <DatePicker
                            id="date-from"
                            selected={startDate}
                            dateFormat={sessionStorage.getItem("date_format")?.replace(/mm/, "MM")}
                            maxDate={new Date()}
                            onChange={(date) => {
                                setStartDate((new Date(Date.UTC(new Date(date)?.getFullYear().toString(), new Date(date)?.getMonth().toString(), new Date(date)?.getDate().toString(), '00', '00', '00'))).getTime())
                            }}
                            className="date-picker test"
                            wrapperClassName=""
                            shouldCloseOnSelect={true}

                        />
                    </div>
                    <div
                        style={{ display: "flex", width: "200px", padding: "0px 0", alignItems: "left", justifyContent: "space-between", flexDirection: "column" }}
                    >
                        <label style={{ width: "40%", }}>To date</label>
                        <DatePicker
                            id="date-to"
                            selected={endDate}
                            dateFormat={sessionStorage.getItem("date_format")?.replace(/mm/, "MM")}
                            maxDate={new Date()}
                            onChange={(date) => {
                                setEndDate((new Date(Date.UTC(new Date(date)?.getFullYear().toString(), new Date(date)?.getMonth().toString(), new Date(date)?.getDate().toString(), '00', '00', '00'))).getTime())
                            }}
                            className="date-picker test"
                            wrapperClassName=""
                            shouldCloseOnSelect={true}

                        />
                    </div>
                    <div
                        style={{ display: "flex", alignItems: "flex-end", height: "100%", justifyContent: "left", flexDirection: "column" }}
                    >
                        <button
                            style={{
                                border: "none",
                                padding: "10px 20px",
                                fontWeight: "bold",
                                color: "white",
                                backgroundColor: "black",
                                cursor: "pointer", marginTop: "15px"
                            }}
                            onClick={onSearch}
                        >
                            <Search style={{ fontSize: "12px" }} /> Search
                        </button>
                    </div>

                </div>
                <div style={{ display: "flex", width: "30%", alignItems: "flex-start", justifyContent: "flex-start", flexDirection: "column", marginLeft: "10px" }}>
                    <div style={{ marginRight: "30px" }}>{active === "order" ? "Order Total: " + totalOrderData() : "Total Sales Qty: " + totalSaleQty()}</div>
                    <div>Total Profit / Loss: {active === "order" ? totalOrderProfitLoss() : totalItemProfitLoss()}</div>
                </div>
                <div style={{ width: "30%", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 20px" }}>
                    <button onClick={() => setActive("order")} style={active === "order" ? { width: "50%", border: "none", color: "#fff", backgroundColor: "#44cd4a", padding: "10px 20px", cursor: "pointer" } : { width: "50%", padding: "10px 18px", backgroundColor: "#000", color: "white", border: "none", cursor: "pointer" }}>Order Wise</button>
                    <button onClick={(e) => { e.stopPropagation(); setActive("item") }}
                        style={active === "item" ? { width: "50%", position: "relative", border: "none", color: "#fff", backgroundColor: "#44cd4a", padding: "10px 20px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" } :
                            { width: "50%", padding: "10px 20px", position: "relative", backgroundColor: "#000", color: "white", border: "none", cursor: "pointer", }}>
                        <b>Item Wise</b>{active === "item" ? <ArrowDropDown onClick={e => { e.stopPropagation(); setStatmentBar(prev => !prev) }} style={{ borderLeft: "2px solid #fff", height: "100%", position: "absolute", right: "0px" }} /> : ""}
                        {statementBar ? <button type='button' onClick={e => { e.stopPropagation(); setActive("statement"); setStatmentBar(prev => !prev) }} style={{ left: "0", top: "120%", padding: "10px 20px", color: "#fff", backgroundColor: "#44cd4a", width: "100%", border: "none", cursor: "pointer", position: "absolute" }}>Statement</button> : ""}
                    </button>
                </div>
            </div>
            <div style={{ paddingLeft: "10px", color: "red" }}>Order Wise Report is More Accurate than Item Wise</div>
            <div
                className="customer-reports-container table-container-user"
                style={{
                    top: "130px"
                }}
            >
                <table className="user-table" id="xlsTableToPrint" style={{ maxWidth: "90vw", overflowX: "scroll" }}>
                    <thead>
                        {active === "order" ? <tr>
                            <th>S.N</th>
                            <th>Working Day</th>
                            <th colSpan="2">Created At</th>
                            <th>Order Number</th>
                            <th>Order Total</th>
                            <th>Profit / Loss</th>
                        </tr> :
                            active === "statement" ? <tr>
                                <th>S.N</th>
                                <th>Created Date</th>

                                <th>Item</th>
                                <th>Sale Qty</th>
                                <th>Cost Price</th>
                                <th>Sale Price</th>
                                <th>Profit / Loss</th>
                            </tr> :
                                <tr>
                                    <th>S.N</th>
                                    <th>Item</th>
                                    <th>Sales Qty</th>
                                    <th>Order Count</th>

                                    <th>Profit / Loss</th>
                                </tr>
                        }
                    </thead>
                    <tbody>
                        {active === "order" ? orderItemsDetails?.map((item, i) =>

                            <tr key={Math.random()}>
                                <td>{i + 1}</td>
                                <td>{dateFormate
                                    ?.replace(
                                        "mm",
                                        ("00" + ((new Date(parseFloat(item.working_day)))?.getMonth() + 1)?.toString())?.slice(-2)
                                    )
                                    ?.replace(
                                        "yy",
                                        ("0000" + (new Date(parseFloat(item.working_day)))?.getFullYear()?.toString())?.slice(-4)
                                    )
                                    ?.replace(
                                        "dd",
                                        ("00" + (new Date(parseFloat(item.working_day)))?.getDate()?.toString())?.slice(-2)
                                    )}</td>
                                <td colSpan="2">{new Date(parseFloat(item.created_at)).toUTCString().replace("GMT", "")}</td>

                                <td>{item.local_order_id}</td>
                                <td>{(+item.order_total)?.toFixed(2)}</td>
                                <td>{(+item.P_L)?.toFixed(2)}</td>
                            </tr>
                        ) : active === "statement" ? statementDetails.filter(a => !itemGroupingFilter || itemGroupingData.find(b => b.item_group_uuid === itemGroupingFilter)?.items?.filter(b => b === a.item_uuid).length).map((item, i) => <tr key={Math.random()}> <td>{i + 1}</td>
                            <td>{dateFormate
                                ?.replace(
                                    "mm",
                                    ("00" + ((new Date(parseFloat(item.created_at)))?.getMonth() + 1)?.toString())?.slice(-2)
                                )
                                ?.replace(
                                    "yy",
                                    ("0000" + (new Date(parseFloat(item.created_at)))?.getFullYear()?.toString())?.slice(-4)
                                )
                                ?.replace(
                                    "dd",
                                    ("00" + (new Date(parseFloat(item.created_at)))?.getDate()?.toString())?.slice(-2)
                                )}</td>
                            <td>{item.item_name}</td>
                            <td>{item.sale_qty}</td>
                            <td>{(+item.cost_price)?.toFixed(2)}</td>
                            <td>{(+item.sales_price)?.toFixed(2)}</td>

                            <td>{(+item.P_L)?.toFixed(2)}</td>
                        </tr>) : itemsDetails.filter(a => !itemGroupingFilter || itemGroupingData.find(b => b.item_group_uuid === itemGroupingFilter)?.items?.filter(b => b === a.item_uuid).length).map((item, i) => <tr key={Math.random()}>
                            <td>{i + 1}</td>
                            <td>{item.item_name}</td>
                            <td>{item.sale_qty}</td>
                            <td>{item.order_count}</td>
                            <td>{(+item.P_L)?.toFixed(2)}</td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        </div>
        {costPopup ? <ItemCosting isItemReportSummary={costPopup} setItemReportSummary={setCostPopup} /> : ""}
    </>
    )
}

export default ProfitAndLoss